export enum RoutePathname {
  DELIVERY = 'delivery',
  PAYMENT = 'payment',
  CONFIRMATION = 'confirmation',
  REGISTRATION = 'registration',
}

export enum ReturnRoutePathnames {
  REGISTERED_RETURNS = 'registered-returns',
  RETURN_ITEMS = 'return-items',
}

export enum RegistrationSearchParameters {
  EMAIL = 'email',
  CALLBACK_URL = 'callbackUrl',
}
